export enum ETipoRelacionamentoVendaNacional {
  COLIGADA = 'Coligada',
  MESMO_GRUPO_ECONOMICO = 'Mesmo grupo econômico',
}
